import { HttpClient } from '@/shared/lib/http-client';

export const sendResetLinkEmail = async({ email }) => {
  const response = await HttpClient.post('/auth/send-reset-link-email', {
    email
  });

  return response.data?.data;
};
